import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceIdIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M4.729 9.086A1.687 1.687 0 0 1 6.306 8c.173 0 .341.053.483.152l.638.447a1 1 0 0 0 1.146 0l.638-.447c.142-.099.31-.152.483-.152.7 0 1.328.432 1.577 1.086l.212.558A1 1 0 0 1 10.55 11H5.45a1 1 0 0 1-.934-1.356l.212-.558ZM9 5.5C9 6.328 8.552 7 8 7s-1-.672-1-1.5S7.448 4 8 4s1 .672 1 1.5ZM5.5 1a.5.5 0 0 1 0 1h-2A1.5 1.5 0 0 0 2 3.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 3.5 1h2ZM10.5 1a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 1 14 3.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 12.5 1h-2ZM3.5 14h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 1 12.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 0 3.5 14ZM10.5 15a.5.5 0 0 1 0-1h2a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5h-2Z"
		/>
	</svg>
))
